import React from "react";
import { FieldError } from "react-hook-form";

import { IBaseFormField } from "shared/types";
import { slideInFromBottom, VisuallyHiddenElement } from "shared/styles/constants";
import { FieldLabel } from "shared/components";
import { FieldWrapperContainer, FieldWrapperChildren, ErrorMessage, Note } from "./styles";
import { useBreakpoint } from "shared/utils";

export type FieldWrapperProps = Pick<
  IBaseFormField,
  "name" | "hideLabel" | "note" | "style" | "fieldLink" | "isHidden" | "tabIndex"
> & {
  label?: string | JSX.Element; // optional in wrapper, required in IBaseFormField
  error?: FieldError | null;
  required?: boolean;
};

export const FieldWrapper: React.FC<FieldWrapperProps> = ({
  isHidden,
  name,
  label,
  hideLabel,
  note,
  error,
  required,
  style,
  fieldLink,
  children,
}) => {
  const isMobile = useBreakpoint();

  const renderInner = () => (
    <FieldWrapperContainer style={isMobile && style?.mobile ? style.mobile : style}>
      {label && (
        <FieldLabel
          name={name}
          label={label}
          hideLabel={hideLabel}
          required={required}
          fieldLink={fieldLink}
        />
      )}
      <FieldWrapperChildren>{children}</FieldWrapperChildren>
      {note && <Note>{note}</Note>}
      {error?.message && (
        <ErrorMessage data-testid="form_field_error" {...slideInFromBottom}>
          {error?.message}
        </ErrorMessage>
      )}
    </FieldWrapperContainer>
  );

  if (isHidden) {
    return (
      <div style={{ visibility: "hidden" }}>
        <VisuallyHiddenElement>{renderInner()}</VisuallyHiddenElement>
      </div>
    );
  }

  return renderInner();
};
